<div
  class="card standalone register-component"
  [ngClass]="{
    'show': isReady()
  }"
>
  <div class="card-header text-center">
    <h1 class="mb-0">
      {{'register.title' | translate}}
    </h1>
  </div>
  <form
    [formGroup]="registerForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="card-body">

      <div
        app-form-input
        field="firstName"
        autocomplete="given-name"
        label="{{'register.first-name.label' | translate}}"
        [isInvalid]="isFieldInvalid('firstName')"
        [isValid]="isFieldValid('firstName')"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid('firstName')"
        >{{'register.first-name.error-message.required' | translate}}</div>
      </div>

      <div
        app-form-input
        field="lastName"
        autocomplete="family-name"
        label="{{'register.last-name.label' | translate}}"
        [isInvalid]="isFieldInvalid('lastName')"
        [isValid]="isFieldValid('lastName')"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid('lastName')"
        >{{'register.last-name.error-message.required' | translate}}</div>
      </div>

      <div
        app-form-input
        field="email"
        autocomplete="username email"
        label="{{'register.email.label' | translate}}"
        [readonly]="emailAsReadOnly"
        [isInvalid]="isFieldInvalid('email')"
        [isValid]="isFieldValid('email')"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="!hasError('email','user_name_reserved')"
        >{{'register.email.error-message.required-or-invalid' | translate}}</div>
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="hasError('email','user_name_reserved')"
        >{{'register.email.error-message.reserved' | translate}}</div>
        <div
          app-form-input-feedback
          type="info"
          *ngIf="emailAsReadOnly"
        >{{'register.email.fixed-by-invitation-info' | translate}}</div>
      </div>

      <div
        app-form-input
        field="password"
        type="password"
        autocomplete="new-password"
        label="{{'register.password.label' | translate}}"
        [isInvalid]="isFieldInvalid('password')"
        [isValid]="isFieldValid('password')"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid('password')"
        >{{'register.password.error-message.required-or-invalid' | translate}}</div>
      </div>

      <div
        app-form-input
        field="confirmPassword"
        type="password"
        autocomplete="new-password"
        label="{{'register.confirm-password.label' | translate}}"
        [isInvalid]="isFieldInvalid('confirmPassword')"
        [isValid]="isFieldValid('confirmPassword')"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid('confirmPassword')"
        >{{'register.confirm-password.error-message.required-or-invalid' | translate}}</div>
      </div>

      <div
        app-form-input
        field="country"
        type="select"
        autocomplete="country"
        label="{{'register.country.label' | translate}}"
        [isInvalid]="isFieldInvalid('country')"
        [isValid]="isFieldValid('country')"
        [selectOptions]="resolveCountryOptions({ label: ('register.country.select-option' | translate), value: null})"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid('country')"
        >{{'register.country.error-message.required' | translate}}</div>
      </div>
      <div [class]="resolveFormInputWrapperClass()">
        <div [class]="resolveFormInputControlWrapperClass()">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              id="acceptTsAndCs"
              name="acceptTsAndCs"
              formControlName="acceptTsAndCs"
              class="custom-control-input"
              [ngClass]="{
                'is-invalid': isFieldInvalid('acceptTsAndCs'),
                'is-valid': isFieldValid('acceptTsAndCs')
              }"
            />
            <label
              class="custom-control-label"
              for="acceptTsAndCs"
            >
              <span [innerHTML]="'register.terms-and-conditions.copy' | translate"></span>
            </label>
            <div
              app-form-input-feedback
              type="invalid"
              *ngIf="isFieldInvalid('acceptTsAndCs')"
            >{{'register.terms-and-conditions.error-message.required' | translate}}</div>
          </div>
        </div>
      </div>
      <app-duke-alert
        type="danger"
        alertClass="mb-0"
        *ngIf="hasError()"
        dismissible="false"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); genericError = false;"
      >
        <p class="mb-0">
          {{'register.submit-error.message' | translate}}
        </p>
      </app-duke-alert>
    </div>
    <div class="card-footer">
      <div class="d-flex align-items-center flex-row-reverse">
        <span
          class="text-danger order-2 mr-2"
          *ngIf="hasError()"
          [@cardFooterFeedbackTransition]
        >
          <span class="icon fa fa-fw fa-exclamation-triangle"></span>
          <span>
            {{'register.submit-error.notification' | translate}}
          </span>
        </span>
        <button
          class="btn btn-success"
          type="submit"
          [disabled]="!registerForm.valid"
        >
          {{'register.register-button.label' | translate}}
        </button>
        <a
          class="btn btn-link order-3 mr-auto"
          [routerLink]="[getAppConstant('PATH_LOGIN')]"
          [queryParams]="this.registerForm.get('email').value ? wrapAsObject(
            [getAppConstant('QP_EMAIL'), this.registerForm.get('email').value]
          ) : wrapAsObject(
            [getAppConstant('QP_EMAIL'), null]
          )"
          queryParamsHandling="merge"
        >
          {{'login.title.default' | translate}}
        </a>
      </div>
    </div>
  </form>
</div>
